import { render } from "./RegressionChart.vue?vue&type=template&id=4c18d0c2&scoped=true"
import script from "./RegressionChart.vue?vue&type=script&lang=js"
export * from "./RegressionChart.vue?vue&type=script&lang=js"

import "./RegressionChart.vue?vue&type=style&index=0&id=4c18d0c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c18d0c2"]])

export default __exports__